import { current } from '@reduxjs/toolkit';
export function updateStockReceiptItemsByMessage({ draft, message, endpointName, eventName, }) {
    const { stockReceiptItem, stockInvoice } = message;
    const itemIndex = draft.receiptItems.findIndex((item) => item.stockReceiptItemId === message.stockReceiptItem.stockReceiptItemId);
    if (itemIndex === -1) {
        // TODO: (later) add error log to backend.
        console.error(`In ${endpointName}() onCacheEntryAdded '${eventName}' event has wrong id: `, message.stockReceiptItem.stockReceiptItemId);
        console.log('Item with the specified it should exist in Invoice items.');
        console.log('Draft:', current(draft));
        console.log('message ', message);
        return;
    }
    draft.receiptItems[itemIndex].receiptedQuantity = stockReceiptItem.receiptedQuantity;
    draft.summary.receiptedQuantity = stockInvoice.receiptedQuantity;
}
